<template lang="html">
  <div class="activitySigned">
    <header></header>
    <main class="container">
      <div class="containerTop">
        <!-- 手机号码 -->
        <div class="formMod">
          <div class="formTitle">
            <span>手机号码</span>
          </div>
          <div class="validatorForm">
            <input type="text" placeholder="请输入手机号码" prop="phone" class="messageInput" v-model="formData.phone"
              @input="handleBlurPhone" @keyup="formData.phone = formData.phone.replace(/[, ]/g, '')">
            <div class="validatorMessage">
              {{ modelControl['phone'] }}
            </div>
          </div>
        </div>
        <!-- 验证码 -->
        <div class="formMod">
          <div class="formTitle">
            <span>验证码</span>
          </div>
          <div class="validatorForm">
            <input type="text" placeholder="请输入验证码" prop="sms_code" class="messageInput" v-model="formData.sms_code"
              @blur="handleBlurSmscode" @keyup="formData.sms_code = formData.sms_code.replace(/[, ]/g, '')">
            <div class="sendCode" :class="[hasSendCode && 'hasSendCode', cannotSendCode && 'hasSendCode']" type="button" name="button" @click="cellPhone()">
              {{ content }}
            </div>
            <div class="validatorMessage">
              {{ modelControl['sms_code'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="containerMiddle">
        <!-- 角色 -->
        <div class="formMod">
          <div class="formTitle">
            <span>我是</span>
          </div>
          <div class="radios">
            <div><input type="radio" name="userType" v-model="formData.user_sign_type" value="1">个人</div>
            <div><input type="radio" name="userType" v-model="formData.user_sign_type" value="2">专家</div>
            <div><input type="radio" name="userType" v-model="formData.user_sign_type" value="3">企业</div>
          </div>
        </div>
        <!-- 技术方向 -->
        <div class="formMod formMod-column" v-if="formData.user_sign_type != 3">
          <div class="formTitle formTitle-column">
            <span>技术方向</span>
            <span>（至少选择1个）</span>
          </div>
          <ul class="categorysList">
            <li v-for="(item, index) in skillsList" :key="index" class="lis" :class="item.class"
              @click="getSkillsIndex(item, index)">
              {{ item.label }}
              <!-- {{item}} -->
            </li>
          </ul>
        </div>
        <!-- 所在行业 -->
        <div class="formMod formMod-column">
          <div class="formTitle formTitle-column">
            <span>所在行业</span>
            <span>（至少选择1个）</span>
          </div>
          <ul class="categorysList">
            <li v-for="(item, index) in industryList" :key="index" class="lis" :class="item.class"
              @click="getIndustryIndex(item, index)">
              {{ item.label }}
            </li>
          </ul>
        </div>
      </div>
      <div class="containerBottom">
        <!-- 姓名 -->
        <div class="formMod" v-if="formData.user_sign_type == 2">
          <div class="formTitle">
            <span>姓名</span>
          </div>
          <div class="validatorForm">
            <input type="text" placeholder="请输入姓名" prop="name" class="messageInput" v-model="formData.name"
              @blur="handleBlurName" @keyup="formData.name = formData.name.replace(/[, ]/g, '')" maxlength="20">
            <div class="validatorMessage">
              {{ modelControl['name'] }}
            </div>
          </div>
        </div>
        <!-- 接口人 -->
        <div class="formMod" v-if="formData.user_sign_type == 3">
          <div class="formTitle">
            <span>接口人</span>
          </div>
          <div class="validatorForm">
            <input type="text" placeholder="请输入接口人" prop="interface_name" class="messageInput"
              v-model="formData.interface_name" @keyup="formData.interface_name = formData.interface_name.replace(/[, ]/g, '')" @blur="handleBlurInterface" maxlength="20">
            <div class="validatorMessage">
              {{ modelControl['interface_name'] }}
            </div>
          </div>
        </div>
        <!-- 职业 -->
        <div class="formMod" v-if="formData.user_sign_type == 1 || formData.user_sign_type == 2">
          <div class="formTitle">
            <span>职业</span>
          </div>
          <div class="validatorForm" @click="clickPosition">
            <input type="text" placeholder="请选择职业" prop="position" class="messageInput" v-model="formData.position"
             @blur="handleBlurPosition">
            <img src="../../assets/image/activitySigned/arrow.png" alt="">
            <div class="validatorMessage">
              {{ modelControl['position'] }}
            </div>
          </div>
        </div>
        <!-- 企业名 -->
        <div class="formMod" v-if="formData.user_sign_type == 2 || formData.user_sign_type == 3">
          <div class="formTitle">
            <span>企业名</span>
          </div>
          <div class="validatorForm">
            <textarea type="text" placeholder="请输入企业名" prop="company" ref="companyInput" class="messageInput" v-model="formData.company"
              @blur="handleBlurCompany" @keyup="formData.company = formData.company.replace(/[, ]/g, '')" @input="companyInputChange" 
              maxlength="30" rows="1"></textarea>
            <div class="validatorMessage">
              {{ modelControl['company'] }}
            </div>
          </div>
        </div>
        <!-- 推荐人 -->
        <div class="formMod" v-if="formData.user_sign_type == 2 || formData.user_sign_type == 3">
          <div class="formTitle">
            <span>推荐人</span>
            <span>(选填)</span>
          </div>
          <input type="text" placeholder="请输入推荐人" class="messageInput" v-model="formData.inviter" @keyup="formData.inviter = formData.inviter.replace(/[, ]/g, '')">
        </div>
        <!-- 提交 -->
        <div class="submitBtn" @click="submit">
          提交
        </div>
        <div class="term validatorForm">
          <!-- @blur="handleBlurTerm" -->
          <input type="radio" prop="term" v-model="formData.termCheck" :value="true" />
          提交即代表您已同意
          <span @click="toPrivacyPolicy">《电巢隐私政策》</span>
          <span @click="toServeAgreement">《电巢服务协议》</span>
          <div class="validatorMessage">
            {{ modelControl['term'] }}
          </div>
        </div>
        <div class="tips">新号码会自动为您创建电巢账号</div>
      </div>
    </main>
    <div class="popup">
      <transition name="fade">
        <div class="popup-overlay" v-if="showPosition" @click="clickPosition"></div>
      </transition>
      <transition name="slide">
        <div class="popup-content" v-show="visible">
          <div class="popupHeader">
            <span @click="clickPosition">取消</span>
            <span>请选择职业</span>
            <span>确定</span>
          </div>
          <ul>
            <li v-for="(item, index) in positionList" :key="index" @click="getPositionsIndex">
              {{ item }}
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils.js';
import Schema from 'async-validator';
import {pagebase} from '@/utils/http'
export default {
  data() {
    return {
      pagebase: pagebase,
      totalTime: 60,
      content: '发送验证码',
      cannotSendCode: true,
      hasSendCode: false,
      phone_validate: false,
      skillsList: [],
      industryList: [],
      skillsSelectedList: [],
      industrySelectedList: [],
      showPosition: false,
      positionList: [
        '学生', '老师', '专家', '工程师', '技术员', '营销', '采购', '人力资源', '主管/经理', '董事长/总经理', '投资者', '其他'
      ],
      visible: false,
      activity_id:'',
      formData: {
        phone: '',
        sms_code: '',
        user_sign_type: '1',
        skillsSelectedList: [],
        industrySelectedList: [],
        skillsReq: '',
        industryReq: '',
        name: '',
        interface_name: '',
        position: '',
        company: '',
        inviter: '',
        termCheck: false,
      },
      formRequest: {},
      rules1: {
        phone: [
          {
            required: true,
            message: '手机号不可以为空'
          },
          {
            required: true,
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: '请输入正确手机号'
          }
        ],
        sms_code: [
          {
            required: true,
            message: '请输入验证码'
          }
        ],
        position: [
          {
            required: true,
            message: '请选择职业'
          }
        ],
      },
      rules2: {
        phone: [
          {
            required: true,
            message: '手机号不可以为空'
          },
          {
            required: true,
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: '请输入正确手机号'
          }
        ],
        sms_code: [
          {
            required: true,
            message: '请输入验证码'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入姓名'
          }
        ],
        company: [
          {
            required: true,
            message: '请输入企业名'
          }
        ],
        position: [
          {
            required: true,
            message: '请选择职业'
          }
        ],
      },
      rules3: {
        phone: [
          {
            required: true,
            message: '手机号不可以为空'
          },
          {
            required: true,
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: '请输入正确手机号'
          }
        ],
        sms_code: [
          {
            required: true,
            message: '请输入验证码'
          }
        ],
        interface_name: [
          {
            required: true,
            message: '请输入接口人'
          }
        ],
        company: [
          {
            required: true,
            message: '请输入企业名'
          }
        ],
      },
      modelControl: {},
    }
  },

  created() {
    this.validator = new Schema(this.rules1);
  },

  mounted() {
    this.init()
  },

  watch: {
    formData: {
      handler(newVal) {
        switch (newVal.user_sign_type) {
          case '1':
            this.rules = this.rules1
            this.formRequest = (({ phone, sms_code, user_sign_type, position }) => ({ phone, sms_code, user_sign_type, position }))(this.formData)
            break;

          case '2':
            this.rules = this.rules2
            this.formRequest = (({ phone, sms_code, user_sign_type, name, position, company, inviter }) => ({ phone, sms_code, user_sign_type, name, position, company, inviter }))(this.formData)
            break;

          case '3':
            this.rules = this.rules3
            this.formRequest = (({ phone, sms_code, user_sign_type, interface_name, company, inviter }) => ({ phone, sms_code, user_sign_type, interface_name, company, inviter }))(this.formData)
            break;

          default:
            break;
        }
        // this.validator.rules = [];
        // this.modelControl = {}
        this.validator = new Schema(this.rules);
      },
      deep: true
    },
  },

  methods: {
    init() {
      this.activity_id = utils.getQuery('activity_id',window.location.href)
      this.$http('/activity/categorys', {
        method: 'get',
      }).then(res => {
        if (res.code >= 0) {
          const { skills, industry } = res.data
          skills.forEach(item => {
            this.skillsList.push({ label: item })
          });
          for (let i = 0; i < this.skillsList.length; i++) {
            this.$set(this.skillsList[i], 'class', '')
            if (i == 0) {
              this.getSkillsIndex(this.skillsList[i], 0)
            }
          }

          industry.forEach(item => {
            this.industryList.push({ label: item })
          });
          for (let i = 0; i < this.industryList.length; i++) {
            this.$set(this.industryList[i], 'class', '')
            if (i == 0) {
              this.getIndustryIndex(this.industryList[i], 0)
            }
          }

          this.formRequest = (({ phone, sms_code, user_sign_type, position }) => ({ phone, sms_code, user_sign_type, position }))(this.formData)
        }
      })
    },

    handleBlurPhone(e) {
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.validator.validate({ phone: this.formData.phone }, (errors, fields) => {
        if (errors && fields.phone) {
          this.$set(this.modelControl, prop, fields[prop][0].message);
          // 此时验证码标灰
          this.cannotSendCode = true
          return errors;
        }
        this.$set(this.modelControl, prop, null);
        this.cannotSendCode = false
      });
    },
    handleBlurSmscode(e) {
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.validator.validate({ sms_code: this.formData.sms_code }, (errors, fields) => {
        if (errors && fields.sms_code) {
          this.$set(this.modelControl, prop, fields[prop][0].message);
          return errors;
        }
        this.$set(this.modelControl, prop, null);
        this.cannotSendCode = false
      });
    },
    handleBlurName(e) {
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.validator.validate({ name: this.formData.name }, (errors, fields) => {
        if (errors && fields.name) {
          this.$set(this.modelControl, prop, fields[prop][0].message);
          return errors;
        }
        this.$set(this.modelControl, prop, null);
      });
    },
    handleBlurPosition(e) {
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.validator.validate({ user_sign_type: this.formData.user_sign_type }, (errors, fields) => {
        if (errors && fields.user_sign_type) {
          this.$set(this.modelControl, prop, fields[prop][0].message);
          return errors;
        }
        this.$set(this.modelControl, prop, null);
      });
    },
    handleBlurInterface(e) {
      // this.showPosition = false
      // this.visible = false
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.validator.validate({ interface_name: this.formData.interface_name }, (errors, fields) => {
        if (errors && fields.interface_name) {
          this.$set(this.modelControl, prop, fields[prop][0].message);
          return errors;
        }
        this.$set(this.modelControl, prop, null);
      });
    },
    handleBlurCompany(e) {
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.validator.validate({ company: this.formData.company }, (errors, fields) => {
        if (errors && fields.company) {
          this.$set(this.modelControl, prop, fields[prop][0].message);
          return errors;
        }
        this.$set(this.modelControl, prop, null);
      });
    },
    handleBlurTerm(e) {
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.validator.validate({ term: this.formData.termCheck }, (errors, fields) => {
        if (errors && fields.term) {
          this.$set(this.modelControl, prop, fields[prop][0].message);
          return errors;
        }
        this.$set(this.modelControl, prop, null);
      });
    },

    clickPosition(e) {
      e.target.blur();
      this.showPosition = !this.showPosition
      this.visible = !this.visible
      // this.showPosition = true
      // this.visible = true
    },

    cellPhone() {
      if (this.hasSendCode) {
        return
      }

      this.validator.validate({ phone: this.formData.phone }, (errors, fields) => {
        if (errors && fields.phone) {
          this.$set(this.modelControl, 'phone', fields['phone'][0].message);
          console.log('不通过');
          this.phone_validate = false
          return errors;
        }
        this.$set(this.modelControl, 'phone', null);
        this.phone_validate = true
      });
      if (!this.phone_validate) {
        return
      }

      this.$http({
        url: '/Registered/getPhoneSmsCode',
        method: 'get',
        params: utils.cso({
          phone: this.formData.phone,
          phone_head: 86,
          type: 4,
          client: 'H5'
        })
      }).then((res) => {
        if (res.code == 0) {
          this.hasSendCode = true
          this.content = this.totalTime + 's后重新发送'
          let clock = window.setInterval(() => {
            this.totalTime--
            this.content = this.totalTime + 's后重新发送'
            if (this.totalTime < 0) {
              this.hasSendCode = false
              window.clearInterval(clock)
              this.content = '发送验证码'
              this.totalTime = 60
            }
          }, 1000)
        } else {
          utils.showMessage(res.msg);
        }
      })

    },
    getSkillsIndex(item, index) {
      if (this.skillsSelectedList.indexOf(item) !== -1) {
        if (this.skillsSelectedList.length == 1) {
          return
        }
        this.skillsSelectedList.splice(this.skillsSelectedList.indexOf(item), 1);
        this.skillsList[index]['class'] = '';
      } else {
        this.skillsSelectedList.push(item);
        this.skillsList[index]['class'] = 'active';
      }
      this.skillsReq = this.skillsSelectedList.map(item => item.label).join(',')
    },
    getIndustryIndex(item, index) {
      if (this.industrySelectedList.indexOf(item) !== -1) {
        if (this.industrySelectedList.length == 1) {
          return
        }
        this.industrySelectedList.splice(this.industrySelectedList.indexOf(item), 1);
        this.industryList[index]['class'] = '';
      } else {
        this.industrySelectedList.push(item);
        this.industryList[index]['class'] = 'active';
      }
      this.industryReq = this.industrySelectedList.map(item => item.label).join(',')
    },
    getPositionsIndex(e) {
      this.formData.position = e.target.innerText.trim()
      this.showPosition = !this.showPosition
      this.visible = !this.visible
    },

    submit(e) {
      e.preventDefault();
      this.validator.validate(this.formData)
        .then(() => {
          console.log('验证通过');
          this.request()
        })
        .catch(({ errors, fields }) => {
          console.log('校验不通过');
          for (let key in fields) {
            this.$set(this.modelControl, key, fields[key][0].message);
          }
          return errors;
        });
      // this.request()
    },
    request() {
      if (!this.formData.termCheck) {
        utils.showMessage('请勾选电巢协议');
        return
      }
      if (this.formData.user_sign_type != 3) {
        this.requestApi({
          ...this.formRequest,
          skills: this.skillsReq,
          industry: this.industryReq,
          activity_id: this.activity_id
        })
      } else {
        this.requestApi({
          ...this.formRequest,
          industry: this.industryReq,
          activity_id: this.activity_id
        })
      }
    },
    requestApi(params) {
      this.$http({
        url: '/activity/activitySigned',
        method: 'post',
        params
      }).then((res) => {
        if (res.code >= 0) {
          this.$router.push({
            path: '/activitySignedSuccess',
            query: {
              phone: this.formData.phone,
            }
          });
        }else{
          utils.showMessage(res.msg);
        }
      })
    },
    toPrivacyPolicy() {
      window.location.href = pagebase + '/h5/agreement/elecomPrivacyPolicy.html'
    },
    toServeAgreement() {
      window.location.href = pagebase + '/h5/agreement/elecomServeAgreement.html'
    },
    companyInputChange() {
      this.handleTextAreaHeight(this.formData.company);
    },
    // 
    handleTextAreaHeight(content) {
      let maxHeight = 0;
      let companyInputRef = this.$refs.companyInput
      companyInputRef.style.height = 'auto';
      maxHeight = Math.max(
        content.split(/\r*\n/)?.length * 18 + 20,
        companyInputRef?.scrollHeight
      );
      // 输入框文字最多显示两行
      companyInputRef.style.height = `${Math.min(maxHeight, 50)}px`;
      companyInputRef.scrollTop = companyInputRef.scrollHeight;
    }
  },
}
</script>

<style lang="css" scoped>
header {
  height: 130px;
  background: url('~@/assets/image/activitySigned/bg_ic@2x.png') no-repeat;
  background-size: cover;
}

.activitySigned {
  width: 100%;
  background-color: #FFF;
  overflow: auto;
  box-sizing: border-box;
}

.container {
  position: relative;
  border-radius: 15px 15px 0 0;
  margin-top: -15px;
  z-index: 5;
  height: 100%;
  background-color: #F7F8F8;
}

.containerTop {
  padding: 15px 20px 20px 20px;
  background-color: #FFF;
  border-radius: 15px 15px 0 0;
}

.containerMiddle {
  margin-top: 10px;
  padding: 0 20px 0 20px;
  background-color: #FFF;
}

.containerMiddle .formMod {
  margin-bottom: 11px;
}

.containerBottom {
  margin-top: 10px;
  padding: 0 20px 20px 20px;
  background-color: #FFF;
}

/* form表单 */
.formMod {
  padding: 7px 0;
  display: flex;
  border-bottom: 1px solid #ECECEC;
}

.formMod input:checked {
  accent-color: #F7443F;
}

.formMod .radios {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  font-size: 15px;
  margin-right: 4px;
  color: #333333;
}

.formMod .radios input {
  margin-right: 3.5px;
}

.formMod-column {
  flex-direction: column;
  border-bottom: none;
}

.formTitle {
  display: flex;
  align-items: center;
  width: 97px;
  color: #1D2023;
  font-size: 16px;
}

.formTitle-column {
  width: auto;
}

.formTitle span:nth-child(2) {
  color: #A5A5A6;
  font-weight: 400;
  font-size: 14px;
}

.sendCode {
  position: absolute;
  right: 0px;
  top: 12px;
  font-size: 13px;
  color: #F7443F;
}

.hasSendCode {
  color: #C0C4CC;
}

.formNum {
  height: 13px;
  margin-right: 5.5px;
}

.must {
  height: 9.5px;
  margin-left: 3px;
}

.validatorForm {
  position: relative;
  width: 100%;
  flex: 1;
}
.validatorForm img {
  height: 10px;
  position: absolute;
  top: 17px;
  right: 0px;
}
/* input框 */
.messageInput {
  border: none;
  outline: none;
  height: 42px;
  box-sizing: border-box;
  font-size: 14px;
  flex: 1;
}
textarea.messageInput {
  padding-top: 13px;
  height: 38px;
  width: 100%;
  text-indent: -3px;
  -webkit-margin-start: -4px;
  resize: none;
  overflow-y: hidden;
}

.validatorMessage {
  position: absolute;
  top: 31px;
  color: #F7443F;
  font-size: 11px;
}

/* label标签 */
.categorysList {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 7.5px;
  column-gap: 8.5px;
}

/* 技术方向/所在行业 */
.lis {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 6px 7px 6px;
  background-color: #F8F8F8;
  border: 0.02rem solid #DCDCDC;
  border-radius: 35px;
  color: #333333;
  font-size: 13px;
}

.active {
  background-color: #FE405A;
  color: #fff;
}

/* 提交 */
.submitBtn {
  position: relative;
  width: 100%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-radius: 45px;
  background-color: #F7443F;
  font-size: 16px;
  color: #FFF;
  margin-top: 35px;
}

.term {
  font-size: 12px;
  display: flex;
  justify-content: center;
  margin-top: 7px;
  color: #808598;
}

.term input {
  margin-right: 3px;
}

.term input:checked {
  accent-color: #F7443F;
}

.term span {
  color: #F7443F;
  border-bottom: 1px solid #F7443F;
}

.tips {
  font-size: 12px;
  display: flex;
  justify-content: center;
  margin-top: 7px;
  color: #808598;
  margin-bottom: 38px;
}


.borderColor {
  border: 1px solid red;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter,
.slide-leave-active {
  transform: translate3d(0, 100%, 0);
}

.popup .popup-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  widows: 100vw;
  background: rgba(0, 0, 0, .6);
  z-index: 6;
}

.popup .popup-content {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  transition: transform .3s;
  z-index: 6;
  border-radius: 24px 24px 0 0;
}

.popup-content li {
  display: flex;
  justify-content: center;
  line-height: 43px;
  font-size: 15px;
}

.popup .popup-content .popupHeader {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin-top: 23px;
  border-bottom: 1px solid #ECECEC;
  padding-bottom: 22px;
}

.popupHeader span:nth-child(1) {
  color: #333333;
  margin-left: 20px;
}

.popupHeader span:nth-child(2) {
  font-weight: 700;
  color: #333333;
}

.popupHeader span:nth-child(3) {
  /* color: #F7443F; */
  color: #fff;
  margin-right: 15px;
}</style>
